import React, { useMemo } from "react";
import { Box, Text, Stack } from "@mantine/core";
import QRCode from "qrcode";
import { QRCodeDisplayProps } from "./QRCodeDisplay.types";

export const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({
  activationCode,
  baseUrl = import.meta.env.VITE_ACTIVATION_BASE_URL ||
    "http://localhost:3000/displays/link",
  size = 200,
}) => {
  const activationUrl = useMemo(() => {
    return `${baseUrl}/${activationCode}`;
  }, [baseUrl, activationCode]);

  const [qrCodeDataUrl, setQrCodeDataUrl] = React.useState<string>("");

  React.useEffect(() => {
    const generateQRCode = async () => {
      try {
        const dataUrl = await QRCode.toDataURL(activationUrl, {
          width: size,
          margin: 2,
          color: {
            dark: "#000000",
            light: "#FFFFFF",
          },
        });
        setQrCodeDataUrl(dataUrl);
      } catch (error) {
        console.error("Error generating QR code:", error);
      }
    };

    generateQRCode();
  }, [activationUrl, size]);

  return (
    <Stack align="center" gap="md">
      <Box
        style={(theme) => ({
          padding: theme.spacing.md,
          backgroundColor: theme.colors.white,
          borderRadius: theme.radius.md,
          border: `1px solid ${theme.colors.gray[3]}`,
        })}
      >
        {qrCodeDataUrl ? (
          <img
            src={qrCodeDataUrl}
            alt={`QR Code for activation: ${activationCode}`}
            style={{
              display: "block",
              width: size,
              height: size,
            }}
          />
        ) : (
          <Box
            style={{
              width: size,
              height: size,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text size="sm" c="dimmed">
              Generating QR code...
            </Text>
          </Box>
        )}
      </Box>

      <Stack align="center" gap="xs">
        <Text size="sm" c="dimmed" ta="center">
          Scan this QR code to activate your display
        </Text>
        <Text
          size="xs"
          c="dimmed"
          ta="center"
          style={{ fontFamily: "monospace" }}
        >
          {activationUrl}
        </Text>
      </Stack>
    </Stack>
  );
};
